import apiReq from '../commontools/api.js'
export function  GetGroupAddByGroup(OrderID,GroupID) {

	var url='/GroupAddItem/GetGroupAddByGroup/'+OrderID+'/'+GroupID;
	return apiReq.get(url)
}
export function GetGroupAddByID(GroupAddID){
	var url='/GroupAddItem/GetGroupAddByID/'+GroupAddID;
	return apiReq.get(url)
}
export function GetGroupAddItemByID(GroupAddID){
	var url='/GroupAddItem/GetGroupAddItemByID/'+GroupAddID;
	return apiReq.get(url)
}
export function SaveGroupAddItem(groupaddid,salemodulesjson){
	var url='/GroupAddItem/SaveGroupAddItem/'+groupaddid;
	// alert(JSON.stringify(salemodulesjson) )
	var p = {
		data: salemodulesjson
	}
	// url+=JSON.stringify(p);
	return apiReq.post(url,p);
}
export function AddGroupAdd(info){
	var url='/GroupAddItem/AddGroupAdd';
	var p = {
		data: info
	}
	return apiReq.post(url,p)
}
export function EditGroupAdd(info){
	var url='/GroupAddItem/EditGroupAdd';
	var p = {
		data: info
	}
	return apiReq.post(url,p)
}
export function DelGroupAdd(OrderID,GroupID,GroupAddID){
	var url='/GroupAddItem/DelGroupAdd/'+OrderID+'/'+GroupID+'/'+GroupAddID;

	return apiReq.get(url)
}
export default{
	GetGroupAddByGroup,
	GetGroupAddByID,
	GetGroupAddItemByID,
	SaveGroupAddItem,
	AddGroupAdd,
	EditGroupAdd,
	DelGroupAdd
}